export default {
  titleContainer: {
    padding: 40,
    mt: ['24px', '24px', '40px', '40px', '92px']
  }
};